module.exports = __webpack_public_path__ + "img/en.d3ddd602.svg";